<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-row align-h="between" style="margin-bottom: 1rem">
      <b-col><h5>水稻 - 葉稻熱病、穗稻熱病</h5></b-col>
      <b-col cols="auto" style="display: inline-flex;">
        <label style="margin-right: 0.5rem;">
          <b-button
            v-if="showmanage.add"
            style="float: right;"
            variant="primary"
            @click="object.ifshowmodal = true"
            >匯入Excel</b-button
          >
        </label>
        <label style="margin-right: 0.5rem;">
          <a
              href="https://agri-data.cyhg.gov.tw/Chiayi/uplode/114%e6%b0%b4%e7%a8%bb%e8%aa%bf%e6%9f%a5%e5%8c%af%e5%85%a5%e7%af%84%e4%be%8b%e6%aa%94.xlsx"
              download="水稻調查匯入範例檔.xlsx"
            >
              <b-button>範本下載</b-button>
            </a>
        </label>
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 1rem">
      <b-col cols="10">
        <span>
          調查日期:
        </span>
        <span>
          <b-form-select
            style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
            v-model="object.yearlist.value"
            :options="object.yearlist.options"
          ></b-form-select>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          :items="object.items"
          :fields="checkeditfield"
          :busy="object.isBusy"
          responsive
          striped
          bordered
          outlined
          hover
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #thead-top head-variant="dark">
            <b-tr class="thead-dark">
              <b-th>病蟲害</b-th>
              <b-th colspan="12">葉稻熱病</b-th>
              <b-th colspan="12">穗稻熱病</b-th>
              <b-th rowspan="3">其他</b-th>
              <b-th v-if="showmanage.delete" rowspan="3">功能</b-th>
            </b-tr>
            <b-tr class="thead-dark">
              <b-th>調查地點</b-th>
              <b-th colspan="6">豐收</b-th>
              <b-th colspan="6">菁埔</b-th>
              <b-th colspan="6">豐收</b-th>
              <b-th colspan="6">菁埔</b-th>
            </b-tr>
            <b-tr class="thead-dark">
              <b-th>調查日期/分級</b-th>
              <b-th>0</b-th>
              <b-th>1</b-th>
              <b-th>2</b-th>
              <b-th>3</b-th>
              <b-th>4</b-th>
              <b-th>5</b-th>
              <b-th>0</b-th>
              <b-th>1</b-th>
              <b-th>2</b-th>
              <b-th>3</b-th>
              <b-th>4</b-th>
              <b-th>5</b-th>
              <b-th>0</b-th>
              <b-th>1</b-th>
              <b-th>2</b-th>
              <b-th>3</b-th>
              <b-th>4</b-th>
              <b-th>5</b-th>
              <b-th>0</b-th>
              <b-th>1</b-th>
              <b-th>2</b-th>
              <b-th>3</b-th>
              <b-th>4</b-th>
              <b-th>5</b-th>
            </b-tr>
          </template>
          <template #cell(EDIT)="data">
            <b-button
              v-if="showmanage.delete"
              variant="danger"
              @click="deleteProcess(data.item)"
              >刪除</b-button
            >
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-modal
      v-model="object.ifshowmodal"
      id="modal-center"
      centered
      title="病蟲害資料Excel匯入"
      @ok="onExelUpload"
      @cancel="restFile"
    >
      <b-form-group label="檔案上傳">
        <b-form-file
          v-model="object.file"
          :state="Boolean(object.file)"
          placeholder="請選擇檔案"
          drop-placeholder="Drop file here..."
          browse-text="瀏覽"
          accept=".xls,.xlsx"
        ></b-form-file>
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="danger" @click="cancel()">
          取消
        </b-button>
        <b-button size="sm" variant="success" @click="ok()">
          上傳
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      object: {
        items: [
          {
            CM_DATE: "110/1/25",
            f_0: 0,
            f_1: 4.8,
            f_2: 0.2,
            f_3: 0,
            f_4: 0,
            f_5: 0,
            g_0: 0,
            g_1: 4.9,
            g_2: 0.2,
            g_3: 0,
            g_4: 0,
            g_5: 0,
            h_0: 0,
            h_1: 0,
            h_2: 0,
            h_3: 0,
            h_4: 0,
            h_5: 0,
            i_0: 0,
            i_1: 0,
            i_2: 0,
            i_3: 0,
            i_4: 0,
            i_5: 0,
          },
        ],
        allitems: [],
        fields: [
          {
            key: "S_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_0",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_1",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_3",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_4",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_5",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_0",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_1",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_3",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_4",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_5",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_0_2",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_1_2",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_2_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_3_2",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_4_2",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_5_2",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_0_2",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_1_2",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_2_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_3_2",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_4_2",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_5_2",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_OTHER",
            label: "其他",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "EDIT",
            label: "功能",
            thClass: "hideheadr",
            visible: false,
          },
        ],
        fields2: [
          {
            key: "S_DATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_0",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_1",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_3",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_4",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_5",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_0",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_1",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_3",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_4",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_5",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_0_2",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_1_2",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_2_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_3_2",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_4_2",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_HAR_5_2",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_0_2",
            label: "0",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_1_2",
            label: "1",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_2_2",
            label: "2",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_3_2",
            label: "3",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_4_2",
            label: "4",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_CHI_5_2",
            label: "5",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "S_OTHER",
            label: "其他",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        yearlist: {
          value: null,
          options: [],
        },
        perPage: 10,
        currentPage: 1,
        isBusy: true,
        ifshowmodal: false,
        updating: false,
        file: null,
      },
      formData: null,
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "病蟲害資料維護",
          active: true,
        },
      ],
      showmanage: {
        show: false,
        add: false,
        edit: false,
        delete: false,
        count: 0,
      },
      apiRiceBlasYearList: (data) =>
        this.userRequest.post("API/Default/RiceBlasYearList", data),
      apiRiceBlastManagementList: (data) =>
        this.userRequest.post("API/Default/RiceBlastManagementList", data),
      apiDeleteRiceBlastbyDate: (data) =>
        this.userRequest.post("API/Default/DeleteRiceBlastbyDate", data),
      apiRiceBlastExcelUpload: (data) =>
        this.userRequest.post("API/Default/RiceBlastExcelUpload", data),
    };
  },
  created() {
    this.checkLogin();
  },
  computed: {
    checkeditfield() {
      return this.showmanage.delete == true
        ? this.object.fields
        : this.object.fields2;
    },
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.showmanage.count = 0;
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000022",
        fun: this.checkByPJIDshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000023",
        fun: this.checkByPJIDadd,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000025",
        fun: this.checkByPJIDdelete,
      });
    },
    checkallpermission() {
      if (
        this.showmanage.show ||
        this.showmanage.add ||
        this.showmanage.delete
      ) {
        // window.addEventListener("resize", this.handleResize);
        // this.handleResize();
        this.init();
      } else {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      }
    },
    checkByPJIDshow(value) {
      this.showmanage.count++;
      if (value) this.showmanage.show = true;
    },
    checkByPJIDadd(value) {
      this.showmanage.count++;
      if (value) this.showmanage.add = true;
    },
    checkByPJIDdelete(value) {
      this.showmanage.count++;
      if (value) this.showmanage.delete = true;
    },
    init() {
      this.FunctionToken(this.getRiceBlasYearList, {});
    },
    getRiceBlasYearList(data) {
      this.apiRiceBlasYearList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            var data = JSON.parse(json.Data);
            this.object.yearlist.value = data[0];
            this.object.yearlist.options = data;
            // let obj = {
            //   YEAR: this.object.yearlist.value,
            // };
            // this.FunctionToken(this.getRiceBlastManagementList, obj);
          }
        })
        .catch((err) => console.warn(err));
    },
    getRiceBlastManagementList(data) {
      this.apiRiceBlastManagementList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            var data = JSON.parse(json.Data);
            this.object.items = data;
            this.object.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    RiceBlastExcelUpload() {
      this.apiRiceBlastExcelUpload(this.formData)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Message == "失敗") {
            alert("匯入失敗！內容有誤，請修正後重新匯入");
            this.object.isBusy = false;
          }

          if (json.Status) {
            var data = JSON.parse(json.Data);
            if (data.status == "success") {
              alert("資料上傳成功");
              this.getdata();
            }
          }
        })
        .catch((err) => console.warn(err));
    },
    deleteRiceBlastbyDate(data) {
      this.apiDeleteRiceBlastbyDate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert("刪除成功");
            this.getdata();
          }
        })
        .catch((err) => console.warn(err));
    },
    onExelUpload() {
      this.formData = new FormData();
      this.formData.append("file", this.object.file);
      this.object.isBusy = true;
      this.FunctionToken(this.RiceBlastExcelUpload, {});
    },
    restFile() {
      this.formData = null;
      this.object.file = null;
    },
    deleteProcess(item) {
      if (confirm("確定要刪除此資料?")) {
        this.FunctionToken(this.deleteRiceBlastbyDate, {
          S_DATE: item.S_DATE,
        });
      }
    },
    getdata() {
      let obj = {
        YEAR: this.object.yearlist.value,
      };
      this.object.isBusy = true;
      this.FunctionToken(this.getRiceBlastManagementList, obj);
    },
  },
  watch: {
    "object.yearlist.value"() {
      this.getdata();
    },
    "showmanage.count"(val) {
      if (val == 3) {
        this.checkallpermission();
      }
    },
  },
};
</script>
